// extracted by mini-css-extract-plugin
export default {"whs":"_PaymentFrequency_whs__LIYW3","nextPayout":"_PaymentFrequency_nextPayout__XDtw2"};